<h1 mat-dialog-title>{{ 'dialog.invite_code_title' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'dialog.invite_code_description' | translate }}</p>
    <h2 class="code">{{ code }}</h2>
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>{{ 'dialog.ok' | translate }}</button>
</div>